angular
	.module 'App.Repository'

.factory 'HelperRepository', ['BaseRepository', (BaseRepository) ->
	class HelperRepository extends BaseRepository
		@resource = '/helpers'
		@isRestricted = true

		serverTime: ->
			return @find 'server_time'

		periodToTime: (period) ->
			return @find 'period_to_time?period=' + encodeURIComponent(period)
				.then (response) ->
					return response.data

	return new HelperRepository
]
